// extracted by mini-css-extract-plugin
export var title = "title-module--title--oQFAC";
export var h1 = "title-module--h1--2uhE-";
export var h2 = "title-module--h2--rivs6";
export var h3 = "title-module--h3--gx2Nq";
export var h4 = "title-module--h4--1fPgs";
export var p = "title-module--p--2xeP8";